import GenericTab from "./genericTab";

export default GenericTab;
